import axios from 'axios'
import config from '@/config'

export default {
    updateProfile(username, email) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        http.defaults.headers.common['Content-Type'] = 'application/json'
        return http.post(`/users/updateProfile/`+username+'/'+email+'/'+localStorage._usercode, {
            "username": username,
            "email": email
        });
    },
    updatePassword(oldpass,newpass) {
        const http = axios.create({
            baseURL: config.API_URL
        });
        return http.post(`/users/updatePassword/`+oldpass+'/'+newpass+'/'+localStorage._usercode, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
    },
}